const BILLABLE_TYPE = {
  ORGANIZATION: "organization",
  TEAM: "team",
  USER: "user",
};

export default BILLABLE_TYPE;
